/* eslint-disable react-hooks/rules-of-hooks */

import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Subtitle, ContainerArrow, ContainerArrowRight } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import LoaderContext from '../../contexts/LoaderContext';


const CarouselNavigation = ({ idOperation, children, hideNavigation, globalAuthContext, idProduct }) => {
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(globalAuthContext);
  const mc = new MessageCenter();
  const [operationsList, setOperationsList] = useState([]);
  const [operation, setOperation] = useState({});
  const [positionArray, setPositionArray] = useState(null);
  const [isMasterPolicy, setIsMasterPolicy] = useState(false);
  const [operationNavigation, setOperationNavigation] = useState(null);
  const { updateIsLoadingStatus } = useContext(LoaderContext);

  async function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(idOperation)
      .then(response => response.json())
      .then(response => {
        setIsMasterPolicy(response.isMasterPolicy);
        setOperation(response);
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data: \n" + error);
      });
  }

  const checkOperationRoute = (idOperation, idProduct, idDomainStatusDoc) => {
    updateIsLoadingStatus(true);
    fitinsur.setAuthToken(authContext.token);
    fitinsur
      .requestPolicyNavigation(idOperation)
      .then((x) => x.json())
      .then((res) => {
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details);
          return;
        }
        let route =
          res.ret_value.route || `/edit-enquiry/${idProduct}/${idOperation}`;
        if (route) {
          updateIsLoadingStatus(false);
          history.push({ pathname: route, state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { status: idDomainStatusDoc, idProduct: idProduct } });
          document.location.reload();
        } else {
          setOperationNavigation(null);
          mc.error("NAVIGATION NOT DEFINED");
          updateIsLoadingStatus(false);
        }
      })
      .catch(() => updateIsLoadingStatus(false));
  };

  async function getDocumentOperations() {
    if (idOperation) {
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestListDocumentOperations(idOperation).then(response => response.json())
        .then(data => {
          if (data.ret_code !== 200) {
            mc.error(data.ret_msg_details);
            return;
          }
          setOperationsList(data.ret_value.operationsList);
        })
    }
  }

  useEffect(() => {
    if (operationsList.length) {
      const arrayPosition = operationsList.findIndex(operation => operation.idOperation == idOperation);
      setPositionArray(arrayPosition);
    }
  }, [operationsList]);

  useEffect(() => {
    if (idOperation) getDocumentOperations();
    getOperationInfo();
  }, []);

  useEffect(() => {
    if (operationNavigation) {
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestOperationInfo(operationNavigation).then(response => response.json()).then(response => {
        if (response.idDomain === 27) {
          checkOperationRoute(response.idOperationRoot, idProduct, response.idDomainStatusDoc);
        }
      }).catch((error) => {
        mc.error("There was an error while fetching your data: \n" + error);
      });
      checkOperationRoute(operationNavigation, idProduct, operation?.idDomainStatusDoc);
    }
  }, [operationNavigation]);

  return (
    (idOperation && operationsList) && (
      <Container>
        {(!hideNavigation && !isMasterPolicy && operationsList[positionArray - 1]) &&
          <ContainerArrow>
            <FontAwesomeIcon
              style={{ cursor: 'pointer' }}
              icon={faAngleLeft}
              size="1x"
              color="gray"
              onClick={() => {
                setOperationNavigation(operationsList[positionArray - 1].idOperation); 
              }}
            />
          </ContainerArrow>}

        <Subtitle>{operationsList[positionArray]?.referenceNumber || operation?.referenceNumber || ''}</Subtitle>

        {(!hideNavigation && !isMasterPolicy && operationsList[positionArray + 1]) &&
          <ContainerArrowRight>
            <FontAwesomeIcon
              style={{ cursor: 'pointer' }}
              icon={faAngleRight}
              size="1x"
              color="gray"
              onClick={() => { setOperationNavigation(operationsList[positionArray + 1].idOperation); }}
            />
          </ContainerArrowRight>}
      </Container>
    )
  )
}

export default CarouselNavigation;
